<template>
  <div>
    <b-button
      class="badge badge-secondary mr-2"
      target="_blank"
      @click="freigabeZuruecknehmen"
      style="width: 30px"
      v-b-tooltip.hover
      :title="'Freigabe zurücknehmen'"
      v-if="params.data.isFreigegeben && !istNurLesbareZeile"
    >
      <a>
        <RotateCcw :size="13"></RotateCcw>
      </a>
    </b-button>
    <b-button
      v-if="isErneutFreigebbar && !istNurLesbareZeile"
      class="badge badge-secondary mr-2"
      target="_blank"
      @click="erneutFreigeben"
      style="width: 30px"
      v-b-tooltip.hover
      :title="'Freigabe anpassen'"
    >
      <a>
        <SquarePen :size="13"></SquarePen>
      </a>
    </b-button>
    <b-button
      v-if="!params.data.isFreigegeben && !istNurLesbareZeile"
      class="badge badge-secondary mr-2"
      target="_blank"
      @click="freigeben"
      :style="{ width: '30px', cursor: isFreigebenDisabled ? 'default' : 'pointer' }"
      v-b-tooltip.hover
      :title="'Freigeben'"
      :disabled="isFreigebenDisabled"
    >
      <a>
        <FileCheck :size="13"></FileCheck>
      </a>
    </b-button>
    <b-button
      class="badge badge-secondary"
      target="_blank"
      @click="createAufgabe"
      style="width: 30px"
      v-b-tooltip.hover
      :title="'Aufgabe erstellen'"
    >
      <ListChecks :size="14"></ListChecks>
    </b-button>
  </div>
</template>

<script>
import { FileCheck, ListChecks, RotateCcw, SquarePen } from 'lucide-vue';
import { istNurLesbar } from '@/components/vorgaenge/repru-storno.constants';

export default {
  components: { FileCheck, ListChecks, RotateCcw, SquarePen },
  computed: {
    // Erhaltene Zeilen stornierter Vorgänge zeigen keine Freigabe-Aktionen mehr
    istNurLesbareZeile() {
      return istNurLesbar(this.params?.data);
    },
    isStornoOrTeilstorno() {
      const leistungstyp = this.params?.data?.leistungstyp;
      return leistungstyp === 'Storno' || leistungstyp === 'Teilstorno';
    },
    isFreigebenDisabled() {
      if (this.isStornoOrTeilstorno) {
        const betrag = this.params?.data?.betrag ?? 0;
        return betrag === 0;
      }
      return false;
    },
    isErneutFreigebbar() {
      const data = this.params?.data;
      if (!data) return false;
      const freigabebetrag = data.freigabebetrag;
      const betrag = data.betrag;
      return freigabebetrag != null && freigabebetrag !== 0 && freigabebetrag !== betrag;
    },
  },
  methods: {
    freigeben() {
      const { id, bnr, betrag, waehrung, teilbetraege, freigabebetrag } = this.params.data;
      this.params.rowFreigeben?.({ id, bnr, betrag, waehrung, teilbetraege, freigabebetrag });
    },
    erneutFreigeben() {
      const { id, bnr, betrag, freigabebetrag, waehrung, teilbetraege } = this.params.data;
      this.params.rowErneutFreigeben?.({ id, bnr, betrag, freigabebetrag, waehrung, teilbetraege });
    },
    createAufgabe() {
      const prefixedVerlinkungen = [];
      let idCounter = 0;

      // Füge den Reisetermin hinzu
      const selectedReisetermin = this.params.getSelectedReisetermin?.();
      if (selectedReisetermin) {
        prefixedVerlinkungen.push({
          id: idCounter++,
          typ: 'Reisetermin',
          artifactId: selectedReisetermin.id,
          artifactText: selectedReisetermin.reiseterminkuerzel,
        });
      }

      // Füge den Vorgang hinzu
      prefixedVerlinkungen.push({
        id: idCounter++,
        typ: 'Vorgang',
        artifactId: this.params.data.vorgangId,
      });

      // Füge die aktuelle Leistung hinzu
      if (this.params.data.id) {
        prefixedVerlinkungen.push({
          id: idCounter++,
          typ: 'Leistung',
          artifactId: this.params.data.id,
          artifactText: this.params.data.leistungskuerzel,
          betrag: this.params.data.betrag,
          waehrung: this.params.data.waehrung,
          kreditor: this.params.data.kreditor,
        });
      }

      this.params.onShowModalAufgabeEdit(prefixedVerlinkungen);
    },
    freigabeZuruecknehmen() {
      const { id, bnr, freigabebetrag, waehrung, rechnungsnummer, freigaben } = this.params.data;
      this.params.rowFreigabeZuruecknehmen?.({
        id,
        bnr,
        freigabebetrag,
        waehrung,
        rechnungsnummer,
        freigaben,
      });
    },
  },
};
</script>
